export const toAbsoluteUrl = (pathname: string) => 'src/assets' + pathname
